import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo, useState } from "react";
import { useReactTable, getCoreRowModel, flexRender, createColumnHelper, getPaginationRowModel } from "@tanstack/react-table";
import { NumericFormat } from "react-number-format";
import clsx from "clsx";
import { pageSizeOptions } from "utils/HelperFunction";
import { MenuItem, Select, TextField } from "@mui/material";
import { utils, writeFileXLSX } from "xlsx";
import moment from "moment";
import useExportReportProductDo from "hooks/reportProductDo/useExportReportProductDo";
import CopyToClipboardButton from "fragments/CopyToClipboardButton";
var columnHelper = createColumnHelper();
export default function ReportProductDoTable(param) {
    var data = param.data, branchMultiSelected = param.branchMultiSelected;
    var columns = useMemo(function() {
        var baseColumns = [
            columnHelper.group({
                id: "sku",
                header: "",
                columns: [
                    columnHelper.accessor("sku", {
                        header: "รหัสสินค้า",
                        cell: function(info) {
                            return /*#__PURE__*/ _jsx("div", {
                                className: "tc-9 flex justify-center fs-18 w-full",
                                children: info.getValue() || "-"
                            });
                        }
                    })
                ]
            }),
            columnHelper.group({
                id: "name_th",
                header: "",
                columns: [
                    columnHelper.accessor("name_th", {
                        header: "ชื่อรายการ",
                        cell: function(param) {
                            var row = param.row;
                            return /*#__PURE__*/ _jsxs("div", {
                                className: "flex gap-[10px]",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "fs-16",
                                                children: row.original.name_th
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "fs-12 tc-7 text-nowrap",
                                                children: row.original.barcodes.join(", ")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx(CopyToClipboardButton, {
                                        textToCopy: "".concat(row.original.name_th, "\nBarcode: ").concat(row.original.barcodes.join(", "), "\nRatio: 1 X ").concat(row.original.uml.ratio_unit)
                                    })
                                ]
                            });
                        }
                    })
                ],
                meta: {
                    className: "!text-left min-w-[400px]"
                }
            }),
            columnHelper.group({
                header: "ราคา",
                columns: [
                    columnHelper.accessor("min_avg_discount_before_vat", {
                        header: "MIN",
                        cell: function(info) {
                            return /*#__PURE__*/ _jsx(NumericFormat, {
                                className: "fs-16 font-bold tc-8",
                                displayType: "text",
                                thousandSeparator: ",",
                                decimalScale: 2,
                                fixedDecimalScale: true,
                                value: info.getValue()
                            });
                        }
                    }),
                    columnHelper.accessor("max_avg_discount_before_vat", {
                        header: "MAX",
                        cell: function(info) {
                            return /*#__PURE__*/ _jsx(NumericFormat, {
                                className: "fs-16 font-bold tc-8",
                                displayType: "text",
                                thousandSeparator: ",",
                                decimalScale: 2,
                                fixedDecimalScale: true,
                                value: info.getValue()
                            });
                        }
                    })
                ],
                meta: {
                    className: "bg-[#ff6b00] text-white"
                }
            }),
            columnHelper.group({
                id: "uml",
                header: "",
                columns: [
                    columnHelper.accessor("uml", {
                        header: "หน่วยใหญ่ UML",
                        cell: function(param) {
                            var row = param.row;
                            return /*#__PURE__*/ _jsxs("div", {
                                className: "tc-7 flex justify-center fs-16 font-bold w-full",
                                children: [
                                    "1 X ",
                                    row.original.uml.ratio_unit
                                ]
                            });
                        }
                    })
                ]
            })
        ];
        var dynamicBranchColumns = branchMultiSelected.map(function(branch) {
            return columnHelper.group({
                header: "สาขา ".concat(branch.label, " ").concat(branch.branch_code),
                columns: [
                    columnHelper.display({
                        id: "sold_uml_".concat(branch.value),
                        header: "จำนวนขาย (UML)",
                        cell: function(param) {
                            var row = param.row;
                            var b = row.original.branches.find(function(v) {
                                return v.dim_branch_id === branch.value;
                            });
                            var _b_sold_uml, _row_original_uml_unit_name, _b_sold_ums, _row_original_ums_unit_name;
                            return /*#__PURE__*/ _jsxs("div", {
                                className: "flex justify-center font-bold fs-16 w-full gap-[5px]",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "tc-7",
                                        children: (_b_sold_uml = b === null || b === void 0 ? void 0 : b.sold_uml) !== null && _b_sold_uml !== void 0 ? _b_sold_uml : "-"
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "tc-4",
                                        children: (_row_original_uml_unit_name = row.original.uml.unit_name) !== null && _row_original_uml_unit_name !== void 0 ? _row_original_uml_unit_name : "-"
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "tc-7",
                                        children: (_b_sold_ums = b === null || b === void 0 ? void 0 : b.sold_ums) !== null && _b_sold_ums !== void 0 ? _b_sold_ums : "-"
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "tc-4",
                                        children: (_row_original_ums_unit_name = row.original.ums.unit_name) !== null && _row_original_ums_unit_name !== void 0 ? _row_original_ums_unit_name : "-"
                                    })
                                ]
                            });
                        }
                    }),
                    columnHelper.display({
                        id: "sold_total_ums_".concat(branch.value),
                        header: "จำนวนขาย (UMS)",
                        cell: function(param) {
                            var row = param.row;
                            var _row_original_branches_find;
                            var value = (_row_original_branches_find = row.original.branches.find(function(v) {
                                return v.dim_branch_id === branch.value;
                            })) === null || _row_original_branches_find === void 0 ? void 0 : _row_original_branches_find.sold_total_ums;
                            return /*#__PURE__*/ _jsx(NumericFormat, {
                                className: "fs-16 font-bold tc-8",
                                displayType: "text",
                                thousandSeparator: ",",
                                decimalScale: 0,
                                fixedDecimalScale: true,
                                value: value || 0
                            });
                        }
                    }),
                    columnHelper.display({
                        id: "sum_total_price_before_vat_".concat(branch.value),
                        header: "ยอดรวม Ex.Vat",
                        cell: function(param) {
                            var row = param.row;
                            var _row_original_branches_find;
                            var value = (_row_original_branches_find = row.original.branches.find(function(v) {
                                return v.dim_branch_id === branch.value;
                            })) === null || _row_original_branches_find === void 0 ? void 0 : _row_original_branches_find.sum_total_price_before_vat;
                            return /*#__PURE__*/ _jsx(NumericFormat, {
                                className: "fs-16 font-bold tc-8",
                                displayType: "text",
                                thousandSeparator: ",",
                                decimalScale: 2,
                                fixedDecimalScale: true,
                                value: value || 0
                            });
                        }
                    })
                ],
                meta: {
                    className: "bg-[#ff6b00] text-white"
                }
            });
        });
        return _to_consumable_array(baseColumns).concat(_to_consumable_array(dynamicBranchColumns));
    }, [
        branchMultiSelected
    ]);
    var _useState = _sliced_to_array(useState(""), 2), keywordSearch = _useState[0], setKeywordSearch = _useState[1];
    var filteredData = useMemo(function() {
        if (!keywordSearch) return data;
        var lower = keywordSearch.toLowerCase();
        return data.filter(function(row) {
            var _row_name_th, _row_sku, _row_barcodes;
            return ((_row_name_th = row.name_th) === null || _row_name_th === void 0 ? void 0 : _row_name_th.toLowerCase().includes(lower)) || ((_row_sku = row.sku) === null || _row_sku === void 0 ? void 0 : _row_sku.toLowerCase().includes(lower)) || ((_row_barcodes = row.barcodes) === null || _row_barcodes === void 0 ? void 0 : _row_barcodes.some(function(b) {
                return b.toLowerCase().includes(lower);
            }));
        });
    }, [
        data,
        keywordSearch
    ]);
    var table = useReactTable({
        data: filteredData,
        columns: columns,
        getCoreRowModel: getCoreRowModel(),
        getPaginationRowModel: getPaginationRowModel()
    });
    var visiblePages = useMemo(function() {
        var pageIndex = table.getState().pagination.pageIndex;
        var pageCount = table.getPageCount();
        var result = [];
        for(var i = 0; i < pageCount; i++){
            if (i === 0 || // หน้าแรก
            i === pageCount - 1 || // หน้าสุดท้าย
            i >= pageIndex - 1 && i <= pageIndex + 1 // รอบหน้า current
            ) {
                result.push(i);
            } else if (i === 1 && pageIndex > 3 || i === pageCount - 2 && pageIndex < pageCount - 4) {
            // skip เพื่อไม่ซ้ำกับ ellipsis
            } else if (i === pageIndex - 2 || i === pageIndex + 2) {
                result.push("ellipsis");
            }
        }
        return result;
    }, [
        table.getState().pagination.pageIndex,
        table.getPageCount()
    ]);
    var downloadExcel = useExportReportProductDo().downloadExcel;
    return /*#__PURE__*/ _jsxs("div", {
        className: "",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex justify-between items-center",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "pb-3 mb-2",
                        children: /*#__PURE__*/ _jsx("button", {
                            className: "btn btn-export-st-2 me-auto ",
                            onClick: function() {
                                downloadExcel(data, "report_product_do_".concat(moment().format("YYYY_MM_DD")));
                            },
                            children: "Export"
                        })
                    }),
                    /*#__PURE__*/ _jsx(TextField, {
                        sx: {
                            fontSize: "14px",
                            minWidth: "323px",
                            input: {
                                color: "#333",
                                fontSize: "14px",
                                padding: "10px 14px"
                            },
                            "& .MuiOutlinedInput-root": {
                                borderRadius: "8px"
                            },
                            "& .MuiOutlinedInput-notchedOutline": {
                                borderColor: "#ccc"
                            },
                            "&:hover .MuiOutlinedInput-notchedOutline": {
                                borderColor: "#ff6b00"
                            },
                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                borderColor: "#1976d2"
                            },
                            "& .MuiInputBase-input::placeholder": {
                                color: "#999",
                                fontSize: "14px"
                            }
                        },
                        value: keywordSearch,
                        onChange: function(e) {
                            return setKeywordSearch(e.currentTarget.value);
                        },
                        placeholder: "ค้นหาชื่อสินค้า / รหัสสินค้า /บาร์โค๊ด"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "max-w-full overflow-x-auto mt-[25px]",
                children: /*#__PURE__*/ _jsxs("table", {
                    className: "min-w-full border border-gray-300",
                    children: [
                        /*#__PURE__*/ _jsx("thead", {
                            className: "bg-gray-100",
                            children: table.getHeaderGroups().map(function(headerGroup) {
                                return /*#__PURE__*/ _jsx("tr", {
                                    children: headerGroup.headers.map(function(header) {
                                        var _header_column_columnDef_meta;
                                        return /*#__PURE__*/ _jsx("th", {
                                            colSpan: header.colSpan,
                                            className: clsx("border border-gray-300 px-[20px] py-[15px] text-center fs-16 font-semibold text-nowrap align-top", (_header_column_columnDef_meta = header.column.columnDef.meta) === null || _header_column_columnDef_meta === void 0 ? void 0 : _header_column_columnDef_meta.className),
                                            children: flexRender(header.column.columnDef.header, header.getContext())
                                        }, header.id);
                                    })
                                }, headerGroup.id);
                            })
                        }),
                        /*#__PURE__*/ _jsx("tbody", {
                            children: table.getRowModel().rows.map(function(row) {
                                return /*#__PURE__*/ _jsx("tr", {
                                    className: "border-t border-gray-300",
                                    children: row.getVisibleCells().map(function(cell) {
                                        return /*#__PURE__*/ _jsx("td", {
                                            className: "border border-gray-300 px-[15px] py-2 text-sm",
                                            children: flexRender(cell.column.columnDef.cell, cell.getContext())
                                        }, cell.id);
                                    })
                                }, row.id);
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "flex items-center justify-end mt-4",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "flex items-center gap-[26px]",
                    children: [
                        /*#__PURE__*/ _jsx(Select, {
                            labelId: "demo-simple-select-label",
                            id: "demo-simple-select",
                            value: table.getState().pagination.pageSize,
                            onChange: function(e) {
                                var newSize = Number(e.target.value);
                                table.setPageSize(newSize);
                            },
                            sx: {
                                fontSize: "14px",
                                color: "rgba(76, 78, 100, 0.87)",
                                height: "40px"
                            },
                            children: pageSizeOptions.map(function(size) {
                                return /*#__PURE__*/ _jsx(MenuItem, {
                                    sx: {
                                        fontSize: "14px",
                                        color: "rgba(76, 78, 100, 0.87)"
                                    },
                                    value: size,
                                    children: size
                                }, size);
                            })
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "fs-14 tc-7",
                            children: [
                                table.getState().pagination.pageIndex + 1,
                                " of",
                                " ",
                                table.getPageCount()
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "flex items-center gap-[10px]",
                            children: [
                                /*#__PURE__*/ _jsx("button", {
                                    onClick: function() {
                                        return table.previousPage();
                                    },
                                    disabled: !table.getCanPreviousPage(),
                                    className: "px-2 py-1 rounded disabled:opacity-50",
                                    children: "<"
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "flex items-center justify-center gap-2",
                                    children: visiblePages.map(function(page, i) {
                                        return page === "ellipsis" ? /*#__PURE__*/ _jsx("span", {
                                            className: "px-1 text-gray-500",
                                            children: "..."
                                        }, "ellipsis-".concat(i)) : /*#__PURE__*/ _jsx("button", {
                                            onClick: function() {
                                                return table.setPageIndex(page);
                                            },
                                            className: clsx("w-[28px] h-[28px] flex justify-center items-center rounded-full text-sm", page === table.getState().pagination.pageIndex ? "bg-[#ff6b00] text-white" : "bg-white border border-gray-300 text-gray-700"),
                                            children: page + 1
                                        }, page);
                                    })
                                }),
                                /*#__PURE__*/ _jsx("button", {
                                    onClick: function() {
                                        return table.nextPage();
                                    },
                                    disabled: !table.getCanNextPage(),
                                    className: "px-2 py-1 rounded disabled:opacity-50",
                                    children: ">"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
